import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d2402aa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit__top" }
const _hoisted_2 = { class: "edit__title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit__divider" }, null, -1))
const _hoisted_4 = { class: "edit__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_center = _resolveComponent("center")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_GeneralInfo = _resolveComponent("GeneralInfo")!
  const _component_Promos = _resolveComponent("Promos")!
  const _component_RedirectDomain = _resolveComponent("RedirectDomain")!
  const _component_Postbacks = _resolveComponent("Postbacks")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.ready)
      ? (_openBlock(), _createBlock(_component_center, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_q_spinner, {
              color: "primary",
              size: "3em",
              thickness: 3
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_q_card, {
          key: 1,
          style: {"box-shadow":"none"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.isNew
              ? _ctx.$t('pages.campaighn.steps.editCampaighn.create')
              : `${_ctx.$t('pages.campaighn.steps.editCampaighn.edit')} ID #${
                  _ctx.$route.params.id
                }`), 1),
              _hoisted_3,
              _createVNode(_component_q_card_actions, {
                align: "center",
                class: "text-primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_btn, {
                    disable: _ctx.loading,
                    loading: _ctx.loading,
                    "no-caps": "",
                    style: {"width":"200px"},
                    "text-color": "dark",
                    color: "primary",
                    label: _ctx.$t('btn.save'),
                    type: "submit",
                    onClick: _ctx.onSubmit
                  }, null, 8, ["disable", "loading", "label", "onClick"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_q_form, {
              onSubmit: _ctx.onSubmit,
              onReset: _ctx.onReset
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_GeneralInfo, {
                      onSelect: _ctx.selectOffer,
                      defaultOptions: _ctx.defaultOptions,
                      disable: !_ctx.isMB
                    }, null, 8, ["onSelect", "defaultOptions", "disable"]),
                    (_ctx.campaign.offerId)
                      ? (_openBlock(), _createBlock(_component_Promos, {
                          key: 0,
                          defaultOptions: _ctx.defaultOptions
                        }, null, 8, ["defaultOptions"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_RedirectDomain, { defaultOptions: _ctx.defaultOptions }, null, 8, ["defaultOptions"])
                  ]),
                  _createVNode(_component_Postbacks)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "onReset"]),
            _createVNode(_component_q_card_actions, {
              align: "center",
              class: "text-primary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  disable: _ctx.loading,
                  loading: _ctx.loading,
                  "no-caps": "",
                  "text-color": "dark",
                  style: {"width":"200px"},
                  color: "primary",
                  label: _ctx.$t('btn.save'),
                  type: "submit",
                  onClick: _ctx.onSubmit
                }, null, 8, ["disable", "loading", "label", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
  ]))
}